<template>
  <sky-charts ref="chart"
              :config="chartConfig"
              legendPosition="bottom"
              :showTitle="false"
              :showShadow="false"
              :chartData="data"
              :extend="extend">
    <div slot="header"
         class="header">
      <div class="title">年龄</div>
      <div class="select">
        <el-select v-model="selectVal"
                   placeholder="展示次数"
                   size="mini"
                   @change="change">
          <el-option v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
  </sky-charts>
</template>

<script>
import mixins from "./ga_mixins";
import { audienceReportCount } from "@/common/dictionary.js";
import filters from "@/mixins/filters.js";
export default {
  name: "fb-series-pie",
  mixins: [mixins],
  components: {},
  data () {
    let that = this;
    return {
      selectVal: "impressions",
      options: audienceReportCount,
      selectTitle: '展示次数',
      filterType: 'thousands',
      extend: {
        series: {
          type: 'bar',
          label: {
            show: true,
            position: "top",
            formatter (val) {
              let format = val.seriesName === '消耗' ? 'rmb' : 'thousands'
              return filters.filters[format](val.value)
            }
          }
        },
        tooltip: {
          formatter (_val) {
            let val = _val[0]
            let name = val.seriesName.substring(0, 2)
            let percentage = that.selectVal + 'Percentage'
            let format = val.seriesName === '消耗' ? 'rmb' : 'thousands'
            return `
                ${val.name}</br>
                ${val.seriesName}：${filters.filters[format](val.value)}</br>
                ${name}占比：${that.data[val.dataIndex][percentage]}%
            `
          }
        },
        legend: {
          show: false,
        },
        grid: {
          bottom: 10
        }
      },
      chartConfig: {
        height: "300px",
        type: "veHistogram",
        columns: [],
        rows: [],
        chartSettings: {
          labelMap: {
            'impressions': '展示次数',
            'covers': '覆盖人数',
            'exchangeRateCost': '消耗'
          },
          radius: 80,
          offsetY: "40%",
        }
      },
      data: []
    };
  },
  watch: {
    condition: {
      handler (val) {
        if (val && Array.isArray(val)) {
          this.data = val.filter(item => item.age != 'Unknown');
          this.chartConfig.columns = [
            'age',
            'impressions',
          ]
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 改变排序字段
    change (val) {
      this.selectVal = val;
      this.chartConfig.columns = [
        'age',
        val
      ]
    },
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;
  .el-select {
    width: 130px;
    margin: 0 10px;
  }
}
</style>
